import {gql} from '@apollo/client';

const CREATE_PARTNER_COST_ENTRY_YEAR = gql`
  mutation createBusPartnerCostEntryYear($partnerId: ID!) {
    createBusPartnerCostEntryYear(busPartnerId: $partnerId) {
      year
      busCostEntry {
        adblueCost
        cleaningCost
        currency
        dieselCost
        legalCost
        lngCost
        otherCost
        overheadCost
        repairCostPerDistanceUnit
        repairCostPerMonth
        tiresCost
        year
      }
      busTypeCostEntries {
        id
        busTypeId
        year
        leasingCost
        insuranceCost
        interestCost
        motorVehicleTax
        maintenanceCostPerMonth
        maintenanceCostPerDistanceUnit
        customIdentifier
      }
      driverCostEntry {
        year
        daytimeWeekdaysWorkingHourCost
        nighttimeWeekdaysWorkingHourCost
        daytimeWeekendsWorkingHourCost
        nighttimeWeekendsWorkingHourCost
        replacementCostPerKm
        replacementCostPerHr
        accommodationCostPerNight
      }
      qualityChecked
      qualityCheckedLastEditedAt
    }
  }
`;

export default CREATE_PARTNER_COST_ENTRY_YEAR;
